"use client";
import { useRef, useState } from "react";
import { useOutsideClick } from "./useOutsideClick";

const usePopper = () => {
    const popperRef = useRef(null);
    const anchorRef = useRef<HTMLDivElement | null>(null);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [isInputFocused, setIsInputFocused] = useState(false);

    useOutsideClick([popperRef, anchorRef], () => {
        if (!isInputFocused) setAnchorEl(null);
    });

    const handleInputFocused = (isFocused: boolean) => {
        if (isFocused) setAnchorEl(anchorRef.current);
        setIsInputFocused(isFocused);
    };

    const togglePopper = (open: boolean) => {
        setAnchorEl(open ? anchorRef.current : null);
    };

    return {
        handleInputFocused,
        togglePopper,
        isPopperOpen: !!anchorEl,
        anchorRef,
        popperRef,
        anchorEl,
    };
};

export default usePopper;
